import React from "react";
import { Box } from "@mui/material";
import { styles } from "./styles";
import Typography from "../../../../components/Typography/Typography";
import { GREY } from "../../../../utils/constants/colors";
import { fontWeight } from "../../../../utils/constants/UI";
import MemoryScreen from "../../../Memory/MemoryScreen";

const Security = () => {
  const classes = styles();

  return (
    <Box className={classes.container}>
      <Box className={classes.security}>
        <Box className={classes.SubHeader}>
          <Typography
            size={"md"}
            color={GREY.PRIMARY}
            fontWeight={fontWeight.MEDIUM}
            label="Company Memory"
          />
        </Box>
        <Box className={classes.containSecurityBoxesWidth01}>
          <MemoryScreen isSettings={true} />
        </Box>
      </Box>
    </Box>
  );
};

export default Security;
